import {styled} from "@mui/material/styles"

export type ActiveIndicatorProps = {
    isActive: boolean
}

export type ActiveUnderlineProps = ActiveIndicatorProps & {
    height?: number
}

export const ActiveUnderline = styled("span", {
    shouldForwardProp: prop => !["isActive", "height"].includes(prop as string),
})<ActiveUnderlineProps>`
    display: flex;
    position: absolute;
    bottom: 0;
    height: ${({height}) => height || "0.125"}rem;
    width: 100%;
    background: ${({theme, isActive}) =>
        isActive ? theme.uxfabric.components.tab.nav.default.active.highlightColor : "transparent"};
`

export const ActiveArrow = styled("span", {
    shouldForwardProp: prop => !["isActive"].includes(prop as string),
})<ActiveIndicatorProps>`
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-bottom: 0.5rem solid
        ${({theme, isActive}) =>
            isActive ? theme.uxfabric.components.tab.nav.default.active.highlightColor : "transparent"};
`
